import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages used in the *.metadata.json5
     */

    mandatoryValidation: {
        id: 'fnol.common.sasria-property-incident..mandatoryValidationId',
        defaultMessage: 'Mandatory field validation failed'
    },
    haveLossEstimateMandatory: {
        id: 'fnol.common.sasria-property-incident.haveLossEstimateMandatory',
        defaultMessage: 'Missing required field "Do you have a Loss Estimate?"'
    },
    lossEstimatateMandatory: {
        id: 'fnol.common.sasria-property-incident.lossEstimatateMandatory',
        defaultMessage: 'Missing required field "Loss Estimate"'
    },
    incorrectLossEstimatateMessage: {
        id: 'nol.common.sasria-property-incident.incorrectLossEstimatateMessage.',
        defaultMessage: 'Loss Estimate is an Amount field and cannot accept alphanumeric values'
    },

    fnolLossEstimateErrorTitle: {
        id: 'fnol.common.views.fnol.Loss Estimate validation failed',
        defaultMessage: 'Loss Estimate validation failed'
    },

    fnolLossEstimateErrorMessage: {
        id: 'fnol.common.views.fnol.Value of Loss Estimate cannot be less than R1.0',
        defaultMessage: 'Value of Loss Estimate cannot be less than R1.0'
    },

    fnolLossEstimateErrorMessageLessThan16: {
        id: 'fnol.common.views.fnol.can have no more than 16 digit to left of decimal point',
        defaultMessage: 'can have no more than 16 digit to left of decimal point'
    },
    isThisFinalLossEstimate: {
        id: 'fnol.common.views.fnol.property.Is this FINAL Loss Estimate',
        defaultMessage: 'Is this FINAL Loss Estimate?'
    },
    expressClaim: {
        id: 'fnol.common.views.fnol.property.Express claim',
        defaultMessage: 'Express claim'
    },
    companyRegistrationNumber: {
        id: 'fnol.common.views.fnol.property.Company Registration',
        defaultMessage: 'Company Registration'
    },
    insuredIdentityNumber: {
        id: 'fnol.common.views.fnol.property.Insured Identity Number',
        defaultMessage: 'Insured Identity Number'
    },
    insuredPassportNumber: {
        id: 'fnol.common.views.fnol.property.Insured Passport Number',
        defaultMessage: 'Insured Passport Number'
    },
    passportNoValidationTitle: {
        id: 'fnol.common.policy-property.passportNoValidationTitle',
        defaultMessage: 'Passport Number validation has failed'
    },
    passportNoValidationMessage: {
        id: 'nol.common.policy-property.passportNoValidationMessage.',
        defaultMessage: 'Passport Number must be less than 13 digits and aplha numeric with no spaces.'
    },
    idNoValidationTitle: {
        id: 'fnol.common.policy-property.idNoValidationTitle',
        defaultMessage: 'Identity Number validation has failed'
    },
    idNoValidationMessage: {
        id: 'nol.common.policy-property.idNoValidationMessage.',
        defaultMessage: 'Identity Number must be 13 digit numeric number with no spaces(YYMMDDNNNNNNN).It is a mandatory field.'
    }
});
